module.exports = __webpack_public_path__ + "6e6173c238199ea78d46c39ea6dc3d49.woff";